import * as React from 'react';
import {useMoneyFormatter} from 'src/hooks/useUnits';
import {totalsByCurrency} from 'src/lib/currencyTotals';
import {SelectionBar} from 'src/SelectionBar';
import type {useRawSelectionActions} from 'src/RawTransactionListView/useRawSelectionActions';

/**
 * The selection bar for an activity list: what Create would consume as the
 * total, the list's full action menu under More, and Create as the primary.
 */
export const RawSelectionBar = ({
  actions,
  open,
  onCancel,
}: {
  actions: ReturnType<typeof useRawSelectionActions>;
  /** Select mode with nothing picked yet; the bar shows from the first pick otherwise. */
  open?: boolean;
  onCancel: () => void;
}) => {
  const formatMoney = useMoneyFormatter();
  return (
    <SelectionBar
      open={open || actions.hasSelected}
      count={actions.selectedCount}
      total={totalsByCurrency(
        // What Create would consume: a partly allocated row's remainder.
        actions.selected.map((row) => ({
          amount: row.remainingAmount ?? row.amount,
          currency: row.currency,
        })),
      )
        .map((sum) => formatMoney(sum))
        .join(' · ')}
      menuItems={actions.selectionMenuItems}
      primary={{
        label: 'Create',
        disabled: !actions.canCreateTransaction,
        onClick: () => actions.openCreateTransactionModal(),
      }}
      onCancel={onCancel}
    />
  );
};
